import { Flow } from "../models/flow";
import { IEvaluationStepsConfig } from "../models/shared.model";
import * as Steps from ".";
import { StepProcess } from "../interfaces/stepProcess";
import { Inject, Injector } from "@angular/core";

export class InitFlow {

  evaluationFlow: Flow = null;

  constructor(
    @Inject(Injector) private injector: Injector,
    private config: IEvaluationStepsConfig
  ) {
    this.init();
  }

  getFlow() {
    return this.evaluationFlow;
  }

  private init() {
    this.evaluationFlow = new Flow();

    if (!this.config?.steps)
      return;

    this.config.steps.forEach(item => {
      const stepInstance: StepProcess = new Steps[this.config.name][item.process](this.injector);

      stepInstance.nodeLogId = Date.now() + Math.random();
      this.evaluationFlow.addNode({
        id: item.id,
        logId: stepInstance.nodeLogId,
        process: stepInstance.process,
        description: item.description,
        nodePaths: JSON.parse(JSON.stringify(item.nodePaths))
      });
    });
  }
}
